export default [
  {
    path: "inventory/defective-detail/:id", // 盘点详情
    name: "InventoryDefectiveDetail",
    component: () => import("@/pages/inventory/DefectiveDetail.vue"),
    meta: {
      title: "盘点详情",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/inventory.js